import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Svg from "../components/figs/Svg";

export default function useSelect() {
  const [option, setOption] = useState([
    {
      value: 1,
      label: "LABEL OPTION 1",
    },
    {
      value: 2,
      label: "LABEL OPTION 2",
    },
  ]);
  const [selectedOption, setSelectedOption] = useState([]);
  const init = {
    className: "",
    placeholder: "",
    disabled: false,
    multiple: true,
    disabledAddNewOption: false,
    selectedOption: [],
  };
  const [remote, setRemote] = useState(init);
  const setProp = (key, value) => {
    setRemote((prev) => ({ ...prev, [key]: value }));
  };

  const inputAddNewRef = useRef(null);
  const inputFilterRef = useRef(null);
  const onSaveRef = useRef(() => {});

  const onControl = {
    getSelectedOption: selectedOption,
    setSelectedOption,
    setOption,
    className: (value) => setProp("className", value),
    placeholder: (value) => setProp("placeholder", value),
    disabled: (value) => setProp("disabled", value),
    multiple: (value) => setProp("multiple", value),
    disabledAddNewOption: (value) => setProp("disabledAddNewOption", value),
    option: (value) => setOption(value),
    selectedOption: (value) => setProp("selectedOption", value),
    setOnSaveAddNewOption: (func) => {
      onSaveRef.current = func;
    },
    getTextForSaveAddNewOption: () => inputAddNewRef.current?.value,
  };
  const { msg } = useSelector((s) => s.language);
  const [isOpenOption, setIsOpenOption] = useState(false);
  const [isAddNew, setIsAddNew] = useState(false);
  const [isMouseOverOption, setIsMouseOverOption] = useState(false);
  const [filteredOption, setFilteredOption] = useState(null);

  const onSelect = (data) => {
    const { value, label } = data;
    const isSelected =
      selectedOption.filter((el) => el.value == value).length > 0;
    if (isSelected) {
      setSelectedOption((prev) => {
        const temp = prev.filter((el) => el.value !== value);
        return temp;
      });
    } else {
      if (remote.multiple == true) {
        setSelectedOption((prev) => {
          const temp = [...prev, data];
          return temp;
        });
      } else {
        setSelectedOption([data]);
      }
    }
    inputFilterRef.current.focus();
    if (remote.multiple == false) {
      setIsOpenOption(false);
    }
  };
  const onRemove = (data) => {
    if (remote.disabled) return;
    setSelectedOption((prev) => {
      const temp = prev.filter((el) => el.value !== data.value);
      return temp;
    });
    if (isOpenOption) {
      inputFilterRef.current.focus();
    }
  };
  const onFilter = (e) => {
    const value = e.target.value;
    const filtered = option.filter((el) =>
      `${el.label}`.toLowerCase().includes(`${value}`.toLocaleLowerCase())
    );
    if (value == "") {
      setFilteredOption(null);
    } else {
      setFilteredOption(filtered);
    }
  };
  const onBlurFilter = () => {
    if (isOpenOption == true && isMouseOverOption == false) {
      setIsOpenOption(false);
    }
  };

  const onSaveAddNewOption = () => {
    onSaveRef.current();
    inputAddNewRef.current.value = "";
    inputFilterRef.current.value = "";
    setFilteredOption(null);
    setIsAddNew(false);
    setIsOpenOption(false);
  };

  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpenOption(false);
        setIsAddNew(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside); // 👈 เพิ่มสำหรับมือถือ

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpenOption) {
      inputFilterRef.current.focus();
    }
  }, [isOpenOption]);
  useEffect(() => {
    if (isAddNew) {
      inputAddNewRef.current.focus();
    }
  }, [isAddNew]);
  useEffect(() => {
    if (selectedOption.length == option.length) {
      setIsOpenOption(false);
    }
  }, [selectedOption]);
  const Select = (
    <div
      ref={containerRef}
      onMouseEnter={() => setIsMouseOverOption(true)}
      onMouseLeave={() => setIsMouseOverOption(false)}
      className={`relative rounded-md ${remote.className}`}
    >
      <div
        onClick={() => {
          if (!remote.disabled) {
            inputFilterRef.current.focus();
            setIsOpenOption(true);
          }
        }}
        className={`border flex gap-2 min-h-[2.5rem] rounded-md items-center flex-wrap px-4 py-1 text-[0.8rem] ${
          remote.disabled ? "bg-[var(--soft-22)]" : ""
        }`}
      >
        <input
          type={isOpenOption || selectedOption.length == 0 ? "text" : "hidden"}
          ref={inputFilterRef}
          onChange={onFilter}
          className="outline-none w-full bg-transparent"
          placeholder={remote.placeholder}
          onFocus={() => setIsOpenOption(true)}
          onBlur={onBlurFilter}
          disabled={remote.disabled}
        />
        {selectedOption.map((el, index) => (
          <div
            key={`selected-${el.value}-${index}`}
            className="flex items-center gap-2 px-1 bg-[var(--soft-22)] rounded-md z-[2] text-[var(--primary)]"
          >
            <span className="cursor-default">{el.label}</span>
            <span onClick={() => onRemove(el)} className="cursor-pointer">
              <Svg iconName="close" className="size-2" />
            </span>
          </div>
        ))}
      </div>
      {isOpenOption && (
        <div className="drop-shadow p-2 rounded-md flex flex-col gap-1 absolute w-full bg-[var(--bright)] z-[11]">
          <div className="max-h-[8rem] overflow-y-auto">
            {(filteredOption || option || [])
              .filter((el) => !selectedOption.includes(el))
              .map((el, index) => (
                <div
                  key={index}
                  onClick={() => onSelect(el)}
                  className={`cursor-pointer text-[0.8rem] px-4 py-1 rounded-md text-[var(--primary)] hover:bg-[var(--primary)] hover:text-[var(--bright)] bg-[${
                    selectedOption.map((el) => el.value).includes(el.value)
                      ? "var(--secondary)"
                      : "var(--bright)"
                  }]`}
                >
                  <span>{el.label}</span>
                </div>
              ))}
          </div>
          {remote.disabledAddNewOption == false && (
            <div className="px-2 pt-2 border-t flex items-center text-[var(--primary)] font-bold">
              {isAddNew ? (
                <div className="w-full flex">
                  <input
                    className="font-normal border px-2 py-1 rounded-md outline-none w-full"
                    ref={inputAddNewRef}
                    onBlur={() => {
                      if (!inputAddNewRef.current.value) {
                        setIsAddNew(false);
                        inputFilterRef.current.focus();
                      }
                    }}
                    onChange={onFilter}
                  />
                  <button
                    className="px-4 ml-2 bg-[var(--primary)] rounded-md text-[var(--bright)] text-[0.8rem]"
                    onClick={onSaveAddNewOption}
                  >
                    {msg.save}
                  </button>
                </div>
              ) : (
                <div
                  onClick={() => setIsAddNew(true)}
                  className="cursor-pointer flex items-center gap-2 text-[0.8rem]"
                >
                  <Svg iconName="add" className="size-4" />
                  <div>{msg.add_new}</div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
  return [onControl, Select];
}
